import React from 'react'
import BannerSection from '../../components/shared/BannerSection'
import Tagline from '../../components/shared/Tagline'
import Section from '../../components/shared/Section'
import TreatmentTypes from './treatmentsComponents/TreatmentTypes'
import StillSection from '../../components/shared/StillSection'
import AccessSection from './treatmentsComponents/AccessSection'
import BookingSection from '../../components/shared/BookingSection'

const Treatments = () => {
    return (
        <>
            <BannerSection
                subTitle='Nurturing Movement and Wellness'
                heading='Treatments'
                paragraph='Learn more about our therapeutic services'
            />
            <Tagline
                heading='Comprehensive Rehabilitation Services'
                paragrpah='Individualized Treatment Plans for Better Health'
            />
            <BookingSection />
            <Tagline
                heading="While it's true that poor diet choices and a sedentary lifestyle"
                paragrpah="Poor diet can contribute to being overweight and out of shape, it’s important to recognize that they’re are other underlying factors as well. Genetics, medical conditions, and medications can all play a role. "
            />
            <Section
                heading='Look Deep Into your health'
                imageUrl='/images/section/sectionImg5.png'
                paragraph='The side effect of exercise is mental development and of course, burning body-fat. The combination of a challenging exercise routine and a balanced meal plan is the best known way to lose fat.'
            />
            <Section
                reverse
                imageUrl='/images/section/sectionImg6.png'
                heading='Adopt a Healthier Lifestyle'
                paragraph='The first thing that clients tell me after starting an exercise program is how much better they feel. Most didn’t even realize how bad they felt. -It’s easy to get used to feeling sluggish, achy and unmotivated.'
            />
            <Section
                heading='Improved mental- Wellbeing'
                imageUrl='/images/section/sectionImg4.png'
                paragraph='A positive mindset for life’s experiences and the ability to learn and grow intellectually achieving the best mentality to create a perfect- healthy- body.  '
            />
            <TreatmentTypes />
            <AccessSection />
            <StillSection />
        </>
    )
}

export default Treatments